import { InsuranceEligibility } from './equipment-api.model';

export interface DamageDetails {
  damageDate: Date;
  damageReasonText: string;
  damageReason: string;
}

export interface EquipmentUpgradeSubscription {
  isInQuarantine: boolean;
  quarantineEndDate: Date;
}

export enum MobileReturnMethod {
  ReturnPackage = 'ReturnPackage',
  ShopReturn = 'ShopReturn',
}

export interface CustomerEquipmentUpgradeAgreement {
  naviCustomerNo: string;
  productVersion: EquipmentUpgradeProductVersion;
  equipmentId: number;
  agreementId: string;
  startDate: Date;
  canBeUpgraded: boolean;
  earliestEligibleUpgradeDate?: Date;
  endDate: Date;
  terminatedDate?: Date;
  pauseDate?: Date;
  relatedMsisdn: string;
  msisdnQuarantineEndDate?: Date;
  activeImei: string;
  phoneModel: string;
  upgradeAfterNumberOfMonths: number;
  agreementPeriodInMonths: number;
  monthlyAmount: EquipmentPrice;
  totalAmount: EquipmentPrice;
  remainingAmount: EquipmentPrice;
  earlyUpgradeAmount: EquipmentPrice;
  currentPeriod: number;
  remainingNumberOfPeriods: number;
  remainingNumberOfPeriodsUntilUpgrade?: number;
  hasAccessoryKit: boolean;
  accessoryKit: AccessoryPack;
  hasInsurance: boolean;
  insuranceServiceId?: string;
  monthlyInsuranceAmount?: EquipmentPrice;
  isValidatingImei: boolean;
  isValidImei: boolean;
  hasCompletedImeiValidation: boolean;
  insuranceEligibility: InsuranceEligibility;
  mobileReturnMethod: MobileReturnMethod;
  redemptionId: number;
  claimId: string;
  damageDetails: DamageDetails;
  redemptionStatus?: RedemptionStatus;
}

export enum RedemptionStatus {
  Cancelled = 3,
  RolledBack = 5,
  Initialized = 10,
  Scheduled = 15,
  PendingFinalGrading = 20,
  Completed = 40,
}

export interface AccessoryPack {
  name: string;
  amount: EquipmentPrice;
  servicePeriodInMonths: number;
}

export enum EquipmentUpgradeProductVersion {
  Unknown = 'Unknown',
  V1 = 'V1',
  V2 = 'V2',
}

export interface EquipmentPrice {
  includingVat: number;
  excludingVat: number;
  vatPercentage: number;
}
